/**
 * @owner @Appboy/whats-app
 */

// generated from 85 samples

import { z } from "zod";
import { common } from "../common";
import { triggerAdditionalKeywordFiltersGetSchema } from "./triggerAdditionalKeywordFiltersGetSchema";

export const sentLineInboundMessageTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::SentLineInboundMessage"),
  additional_keyword_filters: triggerAdditionalKeywordFiltersGetSchema,
  subscription_group: z.object({
    id: common.objectId,
    name: z.string(),
  }),
});
